
document.addEventListener('DOMContentLoaded', function () {
  loadSavedData();

  document.getElementById('contact-submit').addEventListener('click', (e) => {
    e.preventDefault();
    const form = document.getElementById('contact-form');

    const formData = new FormData(form);
    // formDataをオブジェクト形式に変換
    const data = {};
    formData.forEach((value, key) => {
      data[key] = value;
    });
    console.log(data);
    const isValid = formValidation(data);
    if (!isValid) return;
    // バリデーションを通過した場合は、確認画面に遷移
    sessionStorage.setItem('contactForm', JSON.stringify(data));

    // 確認画面に入力内容を表示
    const inputConfirmElements = document.querySelectorAll('[id^="confirm-"]');
    inputConfirmElements.forEach((element) => {
      const key = element.id.replace('confirm-', '');
      element.innerHTML = data[key]?.replace(/\n/g, '<br>') || "";
    });

    // #contact-confirm に挿入し、#contact-form を非表示にする
    document.getElementById('contact-form-area').style.display = 'none';
    document.getElementById('contact-confirm').style.display = 'block';
    window.scrollTo(0, 0);
  });
  document.getElementById('contact-form').addEventListener('submit', async (e) => {
    e.preventDefault();
    console.log('submit');
    document.querySelector('button[form="contact-form"]').disabled = true;
    document.querySelector('button[form="contact-form"]').style.cursor = 'not-allowed';
    document.querySelector('button[form="contact-form"]').style.opacity = '0.5';
    const response = await fetch('/tools/seiban-backend-app/contact/create', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(JSON.parse(sessionStorage.getItem('contactForm'))),
    });
    console.log(response);
    const result = await response.json();
    if (result.success) {
      document.getElementById('contact-form-area').remove();
      document.getElementById('contact-confirm').remove();
      document.getElementById('contact-thanks').style.display = 'block';
      sessionStorage.removeItem('contactForm');
    } else {
      alert('エラーが発生しました。');
    }
  });

});

function formValidation(data) {
  let isValid = true;

  const toggleDisplay = (selector, condition) => {
    const element = document.querySelector(selector);
    if (!element) return;
    element.style.display = condition ? 'block' : 'none';
  };

  // 必須項目のバリデーション
  const fields = ['InquiryItemSelection', 'description', 'last_name', 'first_name', 'last_name_kana', 'first_name_kana', 'prefecture', 'city', 'zip', 'address1', 'phone', 'email'];
  fields.forEach(field => {
    const condition = !data[field];
    console.log(field, condition);
    toggleDisplay(`.sbn-c-validate--${field}`, condition);
    if (condition) isValid = false;
  });

  // name="last_name_kana" name="first_name_kana" は、カナ入力のバリデーションを実装する
  const kanaInputs = document.querySelectorAll('[name*=name_kana]');
  const kanaInvalid = Array.from(kanaInputs).some(input => !input.value.match(/^[\u30A0-\u30FF]+$/));
  toggleDisplay('.sbn-c-validate--name-kana', kanaInvalid);
  if (kanaInvalid) isValid = false;

  // 郵便番号の形式が正しいかどうか
  toggleDisplay('.sbn-c-validate--zip-invalid', !data['zip'].match(/^\d{7}$/));
  if (!data['zip'].match(/^\d{7}$/)) isValid = false;

  // 電話番号の形式が正しいかどうか
  toggleDisplay('.sbn-c-validate--phone-invalid', !data['phone'].match(/^(0\d{9,10}|\+\d{1,3}\d{1,4}\d{1,4}\d{4})$/));
  if (!data['phone'].match(/^(0\d{9,10}|\+\d{1,3}\d{1,4}\d{1,4}\d{4})$/)) isValid = false;

  // メールアドレスの形式が正しいかどうか
  toggleDisplay('.sbn-c-validate--email-invalid', !data['email'].match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/));
  if (!data['email'].match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)) isValid = false;

  //旧漢字バリデーション    
  // 旧漢字リスト（正規表現）
  const invalidCharsPattern = /[纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈻鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑萊步𠮷①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮⑯⑰⑱⑲⑳ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡〝〟№㏍℡㊤㊥㊦㊧㊨㈱㈲㈹㍾㍽㍼㍻∮∑∟•]/;

  const last_name = document.querySelector('[name="last_name"]').value;
  const first_name = document.querySelector('[name="first_name"]').value;

  if (invalidCharsPattern.test(first_name) || invalidCharsPattern.test(last_name)) {
    alert("お名前に旧字体や環境依存文字が含まれています。代用漢字、ひらがななど別の文字をご使用ください。");
    isValid = false;
  }

  const city = document.querySelector("[name='city']").value;
  const address1 = document.querySelector("[name='address1']").value;
  const address2 = document.querySelector("[name='address2']").value;

  if (invalidCharsPattern.test(city) || invalidCharsPattern.test(address1) || invalidCharsPattern.test(address2)) {
    alert("住所に旧字体や環境依存文字が含まれています。代用漢字、ひらがななど別の文字をご使用ください。");
    isValid = false;
  }

  // 最初の無効な要素にスクロール
  if (!isValid) {
    const firstInvalidElement = document.querySelector('.sbn-c-validate[style*="block"]');
    firstInvalidElement?.scrollIntoView({ behavior: 'auto', block: 'start' });
    // 250px 上にスクロールする
    window.scrollBy(0, -250);
  }

  return isValid;
}
function loadSavedData() {
  const savedData = sessionStorage.getItem('contactForm');
  if (!savedData) return;
  const data = JSON.parse(savedData);
  const form = document.getElementById('contact-form');
  Object.keys(data).forEach(key => {
    const input = form.querySelector(`[name=${key}]`);
    if (!input) return;
    input.value = data[key];
  });
}

function backToInputForm() {
  document.getElementById('contact-form-area').style.display = 'block';
  document.getElementById('contact-confirm').style.display = 'none';
  window.scrollTo(0, 0);
}